import { ComponentType } from 'react';
import { BeaconView } from '../../../graphQL';
import { StudentsTab } from './StudentsTab';

/**
 * The native MCP component for each Beacon view that has one. A view the API reports as native but
 * that has no entry here falls back to its Hex embed, if one is available.
 */
export const nativeBeaconViews: Partial<Record<BeaconView, ComponentType>> = {
  [BeaconView.Students]: StudentsTab,
};
